<template>
  <modal
    :show-modal="showModal"
    @close-modal="closeModal"
    width="35"
    title="Entity -- Route ID"
  >
    <div class="flex flex-col gap-4">
      <p class="text-green">CODE PREVIEW (FORMAT)</p>
      <div class="entity-name">LK-CE-2020</div>
      <div class="border-b border-gray-500 ">
        <h3 class="font-semibold mb-2">Basic Details</h3>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">MODULE:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Entity:</span>
            <span class="font-semibold inline-block w-2/3">Route ID</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Description:</span>
            <span class="font-semibold inline-block w-2/3">Identification numbering for identifying routes uniquely.</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Maximum Field Length:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">First Number Series:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Dynamic Number Increase:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Last Assigned Number:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Series Seperator:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
      </div>
      
      <div class="border-b border-gray-500 ">
        <h3 class="font-semibold mb-2">Prefix</h3>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Entity Code:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Reference Code:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Code Seperator:</span>
            <span class="font-semibold inline-block w-2/3">Identification numbering for identifying routes uniquely.</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Use Date:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Date Format:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Date Seperator:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
      </div>
      <div >
        <h3 class="font-semibold mb-2">Base String</h3>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Reference Code:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Code Seperator:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Use Date:</span>
            <span class="font-semibold inline-block w-2/3">Identification numbering for identifying routes uniquely.</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Date Format:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
      </div>
      <base-button class="ml-auto" text="Edit Setting" @click="changeRoute()" />
    </div>
  </modal>
</template>

<script>
export default {
  props: ["showModal"],
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    changeRoute(){
      this.$router.push({name: 'EditDNSEntity'})
    }
  },
};
</script>

<style>
hr {
  border: 1px dashed #b7bdcd;
}
.entity-name {
  background: #dae8f6;
  padding: 0.5em;
  text-align: center;
}
</style>